
export default function Results() {
  const stats = [
    { number: '285%', label: 'Average Patient Growth', icon: 'ri-line-chart-line' },
    { number: '200+', label: 'Healthcare Practices Served', icon: 'ri-hospital-line' },
    { number: '3.2x', label: 'Lead-to-Patient Conversion', icon: 'ri-user-add-line' },
    { number: '98%', label: 'Client Retention Rate', icon: 'ri-star-line' }
  ];

  const testimonials = [
    {
      quote: "Our patient volume tripled in 6 months. The automated follow-up system alone has been worth every penny. We never miss a lead anymore.",
      author: "Dr. Sarah Chen, MD",
      role: "Hormone Therapy Clinic",
      rating: 5,
      image: "https://public.readdy.ai/ai/img_res/10b48dd0f01e14694cbdef3a893bb368.jpg"
    },
    {
      quote: "Finally, a marketing agency that understands healthcare compliance. They've helped us grow ethically while maintaining HIPAA standards.",
      author: "Dr. Michael Rodriguez",
      role: "Longevity Medicine Center",
      rating: 5,
      image: "https://readdy.ai/api/search-image?query=Professional%20Hispanic%20male%20doctor%20headshot%20portrait%20wearing%20white%20coat%20confident%20expression%20neutral%20background%20medical%20professional%20portrait%20photography&width=100&height=100&seq=testimonial2&orientation=squarish"
    },
    {
      quote: "The ROI has been incredible. We're booking 40+ new patient consultations per month now, up from 8. Their automation platform is a game-changer.",
      author: "Jennifer Walsh, NP",
      role: "Women's Wellness Clinic",
      rating: 5,
      image: "https://readdy.ai/api/search-image?query=Professional%20Caucasian%20female%20nurse%20practitioner%20headshot%20portrait%20wearing%20scrubs%20warm%20smile%20neutral%20background%20healthcare%20professional%20portrait%20photography&width=100&height=100&seq=testimonial3&orientation=squarish"
    }
  ];

  return (
    <section className="py-24 px-6 lg:px-12 bg-gradient-to-br from-[#F5F3FF] to-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-16 items-center mb-20">
          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-[#7C3AED] font-bold mb-4">
              PROVEN RESULTS
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight mb-6">
              Real Growth for Healthcare Providers
            </h2>
            <p className="text-base text-gray-600 leading-relaxed mb-8">
              We've helped over 200 healthcare practices achieve sustainable patient growth through ethical, HIPAA-compliant marketing strategies.
            </p>
            <div className="grid grid-cols-2 gap-6">
              {stats.map((stat, index) => (
                <div key={index} className="bg-white rounded-xl p-6 shadow-lg">
                  <div className="w-12 h-12 bg-[#7C3AED]/10 rounded-lg flex items-center justify-center mb-3">
                    <i className={`${stat.icon} text-[#7C3AED] text-xl`}></i>
                  </div>
                  <div className="text-3xl font-bold text-gray-900 mb-1">{stat.number}</div>
                  <div className="text-xs text-gray-600">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="relative">
            <div className="w-full h-[450px] rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://readdy.ai/api/search-image?query=Happy%20medical%20practice%20team%20celebrating%20success%20in%20modern%20clinic%20office%20doctors%20and%20staff%20looking%20at%20growth%20charts%20on%20screen%20positive%20atmosphere%20professional%20healthcare%20environment&width=600&height=500&seq=results1&orientation=portrait"
                alt="Successful medical practice team"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-white rounded-xl p-5 shadow-xl">
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 bg-gradient-to-br from-[#7C3AED] to-[#A855F7] rounded-full flex items-center justify-center">
                  <i className="ri-arrow-up-line text-white text-2xl"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold text-gray-900">285%</div>
                  <div className="text-xs text-gray-500">Avg. Patient Growth</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white rounded-xl p-8 shadow-lg">
              <div className="flex items-center gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#7C3AED] text-sm"></i>
                ))}
              </div>
              <p className="text-gray-700 mb-6 leading-relaxed text-sm">"{testimonial.quote}"</p>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full overflow-hidden">
                  <img 
                    src={testimonial.image}
                    alt={testimonial.author}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="font-bold text-gray-900 text-sm">{testimonial.author}</div>
                  <div className="text-xs text-gray-500">{testimonial.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
